import { FunctionComponent } from "react"
import { Progress, ProgressProps, Flex } from "antd"
import { theme } from "src/global/ui/themes/theme"
import { PercentageDisplay } from "src/global/ui/CircularProgress/PercentageDisplay"

export const PROGRESS_THRESHOLD_PERCENTAGE = 80

interface CircularProgressProps extends Omit<ProgressProps, "type"> {
  value: number
  label: string
  threshold?: number
}

export const CircularProgress: FunctionComponent<CircularProgressProps> = ({
  value,
  label,
  threshold = PROGRESS_THRESHOLD_PERCENTAGE,
  ...restProps
}) => {
  const strokeColor = value >= threshold ? theme.colors.success.gxSuccess : theme.colors.warning.colorWarning

  return (
    <Flex style={{ minHeight: theme.spacing.xxxxl }} align="center" justify="center">
      <Progress
        type="circle"
        percent={value}
        size={100}
        strokeColor={strokeColor}
        strokeWidth={8}
        format={() => <PercentageDisplay value={value} />}
        aria-label={`${label}: ${value}%`}
        {...restProps}
      />
    </Flex>
  )
}
